import React, { useEffect, useState, useCallback } from "react";
import { Pagination } from "../../components/atoms/pagination";
import CardWrapper from "../../components/molecules/CardWrapper";
import CardHeader from "../../components/atoms/cardHeader";
import { useDispatch, useSelector } from "react-redux";
import { SettlementThunk } from "../../store/thunks/orderThunk";

export function Settements() {
  const dispatch = useDispatch();
  const {
    list = [],
    loading,
    pageInfo,
  } = useSelector((state) => state.settlements);

  const [offset, setOffset] = useState(0);
  // 🔹 Format date range
  const formatDateRange = (start, end) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    const startFormatted = new Date(start).toLocaleDateString("en-IN", options);
    const endFormatted = new Date(end).toLocaleDateString("en-IN", options);

    return `${startFormatted} to ${endFormatted}`;
  };

  // ✅ Memoized handler
  const handlePageChange = useCallback((newOffset) => {
    setOffset(newOffset);
  }, []);

  // ✅ API call runs when offset changes
  useEffect(() => {
    dispatch(
      SettlementThunk({
        paginationFilter: {
          offset: offset,
          limit: 10,
          order: "DESC",
        },
      }),
    );
  }, [dispatch, offset]);

  // ✅ Memoized download handler
  const handleDownload = useCallback((url) => {
    if (url) {
      window.open(url, "_blank");
    }
  }, []);

  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <CardWrapper>
        <CardHeader
          name="Settlements"
          tooltipText={"View your payment settlements for completed orders."}
        />

        <div className="card-body p-4">
          <table className="table table-bordered m-0 border radius-remove all_domain_table">
            <thead className="text-white bg-gray-700">
              <tr>
                <th className="all_table_id_number text-center">S.No.</th>
                <th className="width text-center">Settlement Range</th>
                <th className="width text-center">Transaction ID</th>
                <th className="width text-center">Total Payable Amount</th>
                <th className="width text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {list?.length > 0 ? (
                list.map((item, index) => (
                  <tr key={item.id}>
                    {/* ✅ Correct serial number with pagination */}
                    <td className="text-center">  {offset * 10 + index + 1}</td>

                    <td className="text-center">
                      {formatDateRange(item.startDate, item.endDate)}
                    </td>

                    <td className="text-center">
                      {item.transactionId ? "#" : ""}
                      {item.transactionId}
                    </td>

                    <td className="text-center">₹ {item.amount.toFixed(2)}</td>

                    <td className="text-center">
                      <button
                        className="btn btn-link p-0"
                        onClick={() => handleDownload(item?.settlementDocument)}
                      >
                        Download PDF
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  {/* ✅ Fix colspan */}
                  <td colSpan="5" className="text-center">
                    {loading ? "Loading..." : "No Data Available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <Pagination
            pageInfo={pageInfo}
            offset={offset}
            setOffset={handlePageChange}
          />
        </div>
      </CardWrapper>
    </div>
  );
}
